module.exports = __webpack_public_path__ + "d9dd14415e6bb28b66c9a64ccf586f0f.pdf";